export const module = {
  info: {
    name: 'jikatel-testing-number',
    caption: 'Jikatel Testing Number'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  sideMenu: {
    caption: 'Jikatel Testing Number',
    icon: 'el-icon-edit-outline',
    routeName: 'module->jikatel-testing-number->panel',
  }
}

export default module
